import HinhAnhMonAn from "../../components/hinh_anh_mon_an/HinhAnhMonAn";
import DeXuatDanhGiaTrangTri from "../../components/danh_gia_trang_tri_v2/DeXuatDanhGiaTrangTri";

const MktSiteMap = [
  {
    name: "Hình ảnh món ăn",
    path: "hinh anh mon an",
    element: <HinhAnhMonAn />,
  },
  {
    name: "Đề xuất đánh giá trang trí món ăn",
    path: "de xuat danh gia trang tri mon an",
    element: <DeXuatDanhGiaTrangTri />,
  },
];

export default MktSiteMap;
